module.exports = __webpack_public_path__ + "assets/f85a026928f0e1b8573cc766263c6e64.png";